const PlanDetails = ({ grid, plan, isLargeContainer, vertical }) => {
  return (
    <div
      className={"plan-details" + (vertical ? " vertical" : "")}
      style={{ display: isLargeContainer ? "none" : "flex" }}
    >
      <div>
        <label>Builder</label>
        <span>{grid?.clientName || "-"}</span>
      </div>
      <div>
        <label>Community</label>
        <span>{grid?.communityName || "-"}</span>
      </div>
      <div>
        <label>Floor Plan</label>
        <span>{plan?.floorplanName || "-"}</span>
      </div>
      <div>
        <label>Beds/Bath</label>
        <span>
          {plan?.bedroomCount || "-"}/{plan?.bathRoomCount || "-"}
        </span>
      </div>
    </div>
  );
};

export default PlanDetails;
